<template>
  <div>
    <MainContainer :zoom="zoom" :center="center" :idProvince="idProvince" />
  </div>
</template>

<script>
import MainContainer from '@/view/components/MainContainer.vue'
export default {
  name: 'ntt',
  components: {
    MainContainer,
  },
  data: function () {
    return {
      zoom: 7,
      center: [-9.4687361, 122.3173851],
      idProvince: '53',
    }
  },
}
</script>

<style lang="scss" scoped></style>
